'use client';

import { cn } from '@/lib/utils/tw-merge';
import { useConsent } from './ConsentProvider';

type Props = {
    className?: string;
    children?: string;
};

// Unstyled on purpose: the use site gives it the look of its sibling links.
export function CookieSettingsLink({ className, children = 'Cookies einstellen' }: Props) {
    const { openSettings } = useConsent();

    return (
        <button type="button" onClick={openSettings} className={cn('cursor-pointer', className)}>
            {children}
        </button>
    );
}
